import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Row, Col} from 'reactstrap';

import { MagstimColor, CurrentTheme } from 'common'

class MagstimPropertyCard extends React.Component {

    render() {
        // console.log('MagstimPropertyCard.render pairs' + JSON.stringify(this.props.listitems));

        return (
            <Wrapper>
                <Row className="ui-header">
                    <Col>
                        <Row className="ui-panel-header">
                           <h5 className="h5-header"> {this.props.title}</h5>
                        </Row>
                    </Col>
                </Row>
                {
                    Object.keys(this.props.listitems).map((key, index) => (
                        <Row key={'Row-' + key + '-' + index} >
                            <Col xs={8} className="ui-panel" >{this.props.listitems[index].name}</Col>
                            <Col xs={4} className="ui-panel" >{this.props.listitems[index].value}</Col>
                        </Row>
                    ))
                }
            </Wrapper>
        );
    }
}

MagstimPropertyCard.propTypes = {
    title: PropTypes.string,
    listitems: PropTypes.array
};

MagstimPropertyCard.defaultProps = {
    title: '',
    listitems: []
};

const Wrapper = styled.div`

    background-color: ${ MagstimColor.MagstimTextBackground };

    .ui-panel-header {
        padding: 10px 5px 0 20px;
        margin-left:0px;
        margin-right:0px;
        color: ${ MagstimColor.MagstimGroupHeaderText };
        background-color: ${ MagstimColor.MagstimCardHeaderBackground };
        border-color: ${ MagstimColor.MagstimCardHeaderBackground };
    }

    .h5-header{
        font-weight: bold;
        font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
        font-size: ${ CurrentTheme().MagstimNavBarFontSize};
    }

    .ui-panel {
        padding: 0 5px 0 20px;
        font-weight: bold;
        line-height: 40px;
        vertical-align: middle;
    }
    .ui-panel:nth-of-type(2n) {
        padding: 0 20px 0 5px;
        font-weight: normal
    }
`;

export default MagstimPropertyCard;